module.exports = __webpack_public_path__ + "img/lucht-first-frame.3f72f387.png";